import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Banner from '../components/Banner';
import BackToTop from '../components/BackToTop';
import { WOW } from 'wowjs';
import '../css/global.css';
import '../css/WorkingAtCDL.css';

const WorkingAtCDL = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        const wow = new WOW({
            live: false
        });
        wow.init();
    }, []);

    return (
        <div className="hide_div">
            <Header />

            <Banner backgroundImage="/wp-content/uploads/2016/02/Untitled-1-1.jpg" />

            <section className="contentwrapper clearfix">
                <div className="content clearfix">
                    <div className="breadcrumbs">
                        <span><a href="/">Home</a></span> &nbsp;&gt;&nbsp; <span>Working at Colombo Dockyard</span>
                    </div>

                    <h1>Working at Colombo Dockyard</h1>

                    <div className="vc_row wpb_row vc_row-fluid">
                        <div className="wpb_column vc_column_container vc_col-sm-12">
                            <div className="vc_column-inner">
                                <div className="wpb_wrapper">
                                    <div className="wpb_text_column wpb_content_element wow fadeInUp">
                                        <div className="wpb_wrapper">
                                            <p>With a Human Resource perspective that is both unique and powerful, a link is established between employee commitment, customer requirements and stakeholder interests.</p>
                                            <p>Our endeavor is to make the new ‘Colombo Dockyard Man’ economically stable, socially responsible, organizationally loyal, internally disciplined, technically competent, functionally knowledgeable and equipped with shared goals to play a lead role in the organizational Human Resource transformation process.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
            <BackToTop />
        </div>
    );
};

export default WorkingAtCDL;
